export const data = [
    {
        id: 1,
        title: 'What is React?',
        content: 'React is a JavaScript library for building user interfaces. It allows developers to create large web applications that can change data, without reloading the page. Its key feature is the ability to build reusable UI components.'
    },
    
    {
        id: 2,
        title: 'What is a component in React?',
        content: 'A component in React is a reusable piece of code that defines how a certain part of the UI should appear. Components can be either class-based or functional, and they can manage their own state and lifecycle methods.'
    },
    {
        id: 3,
        title: 'What is state in React?',
        content: 'State in React is an object that holds data that may change over the lifetime of a component. It allows components to create dynamic and interactive UIs by re-rendering when the state changes.'
    },
    {
        id: 4,
        title: 'What are props in React?',
        content: 'Props (short for properties) are a way of passing data from parent to child components in React. They are read-only and help to make components reusable by allowing them to receive different data.'
    },
    

    
]